// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'
import HomeIndex from '@/views/Home.vue'
import UserProfileView from '@/views/UserProfile.vue'
import PricingView from '@/views/Pricing.vue'
import AboutView from '@/views/About.vue'
import VoiceGalleryView from '@/views/VoiceGallary.vue'
import TextToSpeechProjectsView from '@/views/TTSProjects.vue'
import TTSView from '@/views/TTSView.vue'
// import LimitedOfferView from '@/views/LTO.vue'
// import DevelopersView from '@/views/ForDeveloper.vue'
import CreditManagement from '@/views/CreditManagement.vue'
import keycloak from '@/api/keycloak'
import VoiceDesignerView from '@/views/VoiceDesigner.vue'
import VoiceDesignWorkflow from '@/views/VoiceDesignWorkflow/index.vue'
import ChooseBaseVoice from '@/views/VoiceDesignWorkflow/ChooseBaseVoice.vue'
import TextPrompting from '@/views/VoiceDesignWorkflow/TextPrompting.vue'
import ReferralView from '@/views/Referral.vue'
import RegisterView from '@/views/Register.vue'
import DemoView from '@/views/DemoView.vue'
import { trackPageView } from '@/api/firebaseAnalytics'

const routes = [{
  path: '/',
  component: MainLayout,
  children: [
    {
      path: '', name: 'Home', component: HomeIndex,
      meta: { hideNav: true }
    },
    { path: 'profile', name: 'profile', component: UserProfileView, meta: { requiresAuth: true } },
    { path: 'credit', name: 'credit', component: CreditManagement, meta: { requiresAuth: true } },
    { path: 'pricing', name: 'pricing', component: PricingView },
    { path: 'about', name: 'about', component: AboutView },
    { path: 'voice-gallery', name: 'voice-gallery', component: VoiceGalleryView },
    { path: 'text-to-speech-projects', name: 'text-to-speech projects', component: TextToSpeechProjectsView },
    { path: 'text-to-speech', name: 'text-to-speech', component: TTSView },
    { path: 'voice-designer', name: 'voice-designer', component: VoiceDesignerView },
    { path: 'referral', name: 'referral', component: ReferralView },
    { path: 'register', name: 'register', component: RegisterView },
    { path: 'demo', name: 'demo', component: DemoView },
  ]
}, {
  path: '/voice-design-workflow',
  component: VoiceDesignWorkflow,
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      redirect: '/choose-base-voice'
    },
    {
      path: 'choose-base-voice',
      name: 'choose-base-voice',
      component: ChooseBaseVoice,
      meta: { step: 1 }
    },
    {
      path: 'text-prompting',
      name: 'text-prompting',
      component: TextPrompting,
      meta: { step: 2 }
    }
  ]
}
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

router.beforeEach((to, from, next) => {
  const toStep = to.meta.step ?? 0;
  const fromStep = from.meta.step ?? 0;
  to.meta.transition = toStep > fromStep ? 'slide-left' : 'slide-right';

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth) {
    const authToken = localStorage.getItem('auth_token')

    if (!authToken || authToken === '') {
      console.log('Protected route accessed without auth, prompting login...')
      keycloak.login()
      return
    }
  }

  next()
})

router.afterEach((to) => {
  trackPageView(to)
})

export default router
